// extracted by mini-css-extract-plugin
module.exports = {"input_box":"register_input_box__1cXeD","div":"register_div__2lfaC","form_container":"register_form_container__1TTrk","button":"register_button__13F5j"};